export const uk = {
    add: 'Добавить',
    edit: 'Изменить',
    'upload-error': 'Недопустимый тип файла, используйте графические форматы JPEG, PNG',
    'upload-source': "Завантажити з комп'ютера"
};
